/* RESPONSIBLE TEAM: team-inbox-management */
export enum InboxCategory {
  Shared = 'shared',
  Admin = 'admin',
  Team = 'team',
  View = 'view',
  Dashboard = 'dashboard',
}
